module.exports = __webpack_public_path__ + "static/media/trial-pack.16ebf2a3.png";